export enum EProjectId {
    TwinlandeSuperStore = "twinlande",
    ColonialCarnival = "colonialcarnival",
    ChevEscape = "chevsescape",
    GITRGCrayon = "gitrg3dcrayon",
    GITRGMocap = "mocap",
    RevealingRoc = "revealingroc",
    PawBytes = "pawbytes",
    LovelyFeathers = "lovelyfeathers",
    RocLabs = "roclabs",
    YemiiBot = "yemii-bot",
    RocPortfolio = 'roc-website'
}